module.exports = __webpack_public_path__ + "img/video_consult_bg--new.37b8ac1c.png";